import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type DefaultCarrierByCountryServiceEntryFragmentFragment = { __typename?: 'DefaultCarrierByCountryServiceEntry', carrier_service: Types.OpsOrderCarrierService, carrier: Types.OpsOrderCarrier };

export const DefaultCarrierByCountryServiceEntryFragmentFragmentDoc = gql`
    fragment DefaultCarrierByCountryServiceEntryFragment on DefaultCarrierByCountryServiceEntry {
  carrier_service
  carrier
}
    `;